var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScales(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M23.245 5H8.755C6.243 5 5 6.243 5 8.704v14.591C5 25.757 6.243 27 8.755 27h14.49C25.742 27 27 25.769 27 23.295V8.705C27 6.23 25.742 5 23.245 5zM16 7a9.96 9.96 0 0 1 6.418 2.331L19.75 12A6.222 6.222 0 0 0 16 10.75 6.222 6.222 0 0 0 12.25 12L9.58 9.33A9.96 9.96 0 0 1 16 7z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m14.37 7.132.203 1.234c-.19.03-.377.068-.562.11l-.283-1.217a9.94 9.94 0 0 1 .642-.127zm-1.894.506.44 1.17c-.178.068-.354.14-.528.22l-.516-1.139c.198-.09.4-.173.604-.25zm-1.757.869.66 1.06a8.8 8.8 0 0 0-.475.32l-.73-1.016c.178-.127.36-.249.545-.364zm11.106.364a10.006 10.006 0 0 0-.544-.364l-.66 1.06c.161.102.32.208.475.32zm-1.697-.982-.516 1.138a8.708 8.708 0 0 0-.529-.219l.44-1.17c.205.078.407.161.605.251zm-1.856-.63-.283 1.218a8.686 8.686 0 0 0-.562-.111l.203-1.234c.216.036.43.078.642.127z",
    fillRule: "evenodd",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 7-1 7h2z",
    opacity: 0.6
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScales);
export default __webpack_public_path__ + "static/media/Scales.fc3dd100fa80fe96e8639ac66e5ec03e.svg";
export { ForwardRef as ReactComponent };